<template>
  <footer class="c-footer">
    <div class="c-footer__container">
      <div class="c-footer__top">
        <ul class="c-footer-nav">
          <li class="c-footer-nav__item" v-for="item in footerNav" :key="item.link">
            <router-link :to="item.link" class="link__normal c-footer-nav__link">{{item.title}}</router-link>
          </li>
        </ul>
        <language-picker />
      </div>
      <div class="c-footer__bottom">
        <p class="copyright">
          © 1997–{{date.getFullYear()}} ПАО Сбербанк. Bсe права защищены. <a href="//sberbank.ru" target="_blank" class="link__text">www.sberbank.ru</a>
        </p>
      </div>
    </div>
  </footer>
</template>
<script>
import LanguagePicker from "@/components/language/LanguagePicker";
export default {
  data() {
    return {
      date: new Date(),
      footerNav: [
        { link: "/about", name: "", title: "О платформе", slug: "" },
        {
          link: "/confidential",
          name: "",
          title: "Конфиденциальность",
          slug: ""
        },
        { link: "/disclaimer", name: "", title: "Дисклеймер", slug: "" },
        {
          link: "/user_confirmation",
          name: "",
          title: "Пользовательское соглашение",
          slug: ""
        }
      ]
    };
  },
  components: {
    LanguagePicker
  }
};
</script>
